import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {
  public readonly Int32MAX = 2147483647;
  public readonly Int32MIN = -2147483647;

  isInteger32 = (control: FormControl) => {
    return this.checkIfIsInteger32(control.value)
      ? null
      : {
          notNumeric: true
        };
  };

  private checkIfIsInteger32(value) {
    return !isNaN(value) && this.isValidInt32(parseInt(value));
  }

  private isValidInt32(number: number) {
    return number > this.Int32MIN && number < this.Int32MAX;
  }

  noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }
}
